class AtcSuccessModal extends Popup {
  constructor() {
    super();
  }

  static getInstance() {
    return document.getElementById("atc-success-modal");
  }

  static matches(detail) {
    const modal = AtcSuccessModal.getInstance();
    if (!modal || !detail) return false;
    if (detail.add_type !== "single") return false;
    if (typeof detail.product_id === "undefined") return false;
    return Number(modal.dataset.productId) === Number(detail.product_id);
  }

  connectedCallback() {
    super.connectedCallback();

    this._onCartAdd = this.handleCartAdd.bind(this);
    window.addEventListener("cart:add", this._onCartAdd);

    this.querySelector("[data-atc-view-cart]")?.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
      document.getElementById("cart-drawer")?.open();
    });

    this.querySelectorAll("[data-atc-set-add]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.addSet(btn);
      });
    });
  }

  handleCartAdd(e) {
    if (!AtcSuccessModal.matches(e.detail)) return;
    this.originalLineItemKey = e.detail.key;
    const addedQuantity = Number(e.detail.added_count) || 1;
    const totalQuantity = Number(e.detail.quantity) || addedQuantity;
    this.originalLineItemRemainingQuantity = Math.max(0, totalQuantity - addedQuantity);
    this.populateAdded(e.detail);
    this.resetSwapState();
    this.open();
  }

  populateAdded(detail) {
    const moneyFormat = this.dataset.moneyFormat;
    const img = this.querySelector("[data-atc-added-image] img");
    if (img && detail.image) {
      img.src = detail.image;
    }
    const titleEl = this.querySelector("[data-atc-added-title]");
    if (titleEl) titleEl.textContent = detail.product_title;

    const variantEl = this.querySelector("[data-atc-added-variant]");
    if (variantEl) {
      const hasOnlyDefaultVariant = detail.product_has_only_default_variant;
      variantEl.textContent = hasOnlyDefaultVariant ? "" : detail.variant_title;
      variantEl.hidden = !!hasOnlyDefaultVariant;
    }

    const priceEl = this.querySelector("[data-atc-added-price]");
    if (priceEl) {
      const linePrice = detail.final_line_price ?? detail.line_price;
      priceEl.textContent = Shopify.theme.tools.formatMoney(linePrice, moneyFormat);
    }
  }

  resetSwapState() {
    const grid = this.querySelector("[data-atc-sets-grid]");
    if (grid) grid.hidden = false;
    this.querySelectorAll("[data-atc-set-error]").forEach((el) => {
      el.hidden = true;
    });
    this.querySelectorAll("[data-atc-set-add]").forEach((btn) => {
      btn.disabled = false;
    });
  }

  addSet(button) {
    const card = button.closest("[data-atc-set-card]");
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;

    button.disabled = true;
    card?.classList.add("loading");
    this.hideCardError(card);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status) {
          const error_string = `\nCART ADD FAILED \nStatus: ${response.status} \nMessage: ${response.message} \nDescription: ${response.description}`;
          throw new Error(error_string, { cause: "Cart Error" });
        }
        return this.removeOriginalLine(card);
      })
      .catch((err) => {
        console.error("[atc-success-modal]", err);
        this.showCardError(card);
      })
      .finally(() => {
        button.disabled = false;
        card?.classList.remove("loading");
      });
  }

  removeOriginalLine(card) {
    return new Promise((resolve) => {
      if (!this.originalLineItemKey) {
        resolve();
        return;
      }
      const remainingQuantity = this.originalLineItemRemainingQuantity ?? 0;
      Shopify.theme.cart.updateCart({ updates: { [this.originalLineItemKey]: remainingQuantity } }, true, (cart) => {
        this.refreshCartForms(cart);
        this.showSwapped(card);
        resolve();
      });
    });
  }

  refreshCartForms(cart) {
    document.querySelectorAll("cart-form").forEach((form) => {
      const sectionId = form.section;
      if (cart?.sections?.[sectionId]) {
        form.updateView(cart.sections[sectionId]);
      }
    });
  }

  showSwapped(card) {
    const image = card?.querySelector("[data-set-card-image] img");
    const title = card?.querySelector("[data-set-card-title]")?.textContent;
    const price = card?.querySelector("[data-set-card-price]")?.textContent;

    const targetImg = this.querySelector("[data-atc-added-image] img");
    if (targetImg && image) {
      targetImg.src = image.currentSrc || image.src;
    }
    const titleEl = this.querySelector("[data-atc-added-title]");
    if (title && titleEl) titleEl.textContent = title.trim();

    const variantEl = this.querySelector("[data-atc-added-variant]");
    if (variantEl) variantEl.hidden = true;

    const priceEl = this.querySelector("[data-atc-added-price]");
    if (price && priceEl) priceEl.textContent = price.trim();

    const grid = this.querySelector("[data-atc-sets-grid]");
    if (grid) grid.hidden = true;
  }

  showCardError(card) {
    const error = card?.querySelector("[data-atc-set-error]");
    if (error) error.hidden = false;
  }

  hideCardError(card) {
    const error = card?.querySelector("[data-atc-set-error]");
    if (error) error.hidden = true;
  }
}
customElements.define("atc-success-modal", AtcSuccessModal);
